var scrollbarBox = (function($) {

    var cachedDOM = {}

    function init() {
        cachedDOM.scrollingBox = document.querySelector('.scrollbar-box');
        cachedDOM.$scrollingBox = $(cachedDOM.scrollingBox);
        cachedDOM.$video = $('.embed-video');

        if(!cachedDOM.perfectScrollbar) {
            cachedDOM.perfectScrollbar = new PerfectScrollbar(cachedDOM.scrollingBox)
        }

        events();
        updateScrollbar();
    }

    function updateScrollbar() {
        var boxExtraPadding = 37;
        var videoHeight = cachedDOM.$video.outerHeight() - boxExtraPadding;

        cachedDOM.$scrollingBox.height(videoHeight);
        cachedDOM.perfectScrollbar.update();
    }

    function events() {
        $(window).on('resize', updateScrollbar);
    }

    return {
        init: init,
        updateScrollbar: updateScrollbar
    }

})(jQuery);
